/* ============================================================
   AIGO — Brand directory page
   Handles:
     1. Brand search filtering (A–Z groups, no-results, A-Z nav toggle)
     2. Back-to-top button (show after scrolling 400px, click scrolls to top)
   ============================================================ */

window.FoxTheme = window.FoxTheme || {};

FoxTheme.BrandsPage = {
  init: function () {
    this._initSearch();
    this._initBackToTop();
  },

  // ── 1. Brand search filtering ─────────────────────────────────
  _initSearch: function () {
    var input = document.querySelector('[data-brands-search]');
    if (!input) return;

    var groups  = Array.from(document.querySelectorAll('.brands-az-group[data-brands-group]'));
    var azNav   = document.getElementById('brands-az-nav');
    var noResults = document.querySelector('.brands-no-results');
    var querySpan = noResults ? noResults.querySelector('[data-search-query]') : null;

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();

      var allGroupsHidden = true; // flipped false as soon as one group has a visible card

      groups.forEach(function (group) {
        var cards = Array.from(group.querySelectorAll('.brand-card'));
        var anyVisible = false;

        cards.forEach(function (card) {
          var nameEl = card.querySelector('.brand-card__name');
          var name   = nameEl ? nameEl.textContent.toLowerCase() : '';
          var match  = name.includes(query);

          if (match) {
            card.removeAttribute('hidden');
            anyVisible = true;
          } else {
            card.setAttribute('hidden', '');
          }
        });

        // Hide the entire letter group if all its cards are hidden
        if (anyVisible) {
          group.removeAttribute('hidden');
          allGroupsHidden = false;
        } else {
          group.setAttribute('hidden', '');
        }
      });

      // Toggle A–Z nav: hide when searching, show when query is cleared
      if (azNav) {
        if (query) {
          azNav.setAttribute('hidden', '');
        } else {
          azNav.removeAttribute('hidden');
        }
      }

      // Show no-results message only when query is non-empty and nothing matches
      if (noResults) {
        if (query && allGroupsHidden) {
          if (querySpan) querySpan.textContent = input.value.trim();
          noResults.removeAttribute('hidden');
        } else {
          noResults.setAttribute('hidden', '');
        }
      }
    });
  },

  // ── 2. Back-to-top button ─────────────────────────────────────
  _initBackToTop: function () {
    var btn = document.getElementById('brands-back-top');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
};

// Auto-init after DOM + all deferred scripts are ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    FoxTheme.BrandsPage.init();
  });
} else {
  FoxTheme.BrandsPage.init();
}
